import React, { Fragment, useState, useRef, useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import Toast from "../../toast/SetToast";
import {
  notifyTopRight,
  notifyWarning,
  notifyError,
} from "../../toast/SetToast";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../../../firebase";
import { useFirestore } from "../../../../hook/useFirestore";

import { DoctorEditForm } from "./DcotorEditForm";

const DoctorEdit = (props) => {
  const { updateDocument } = useFirestore("doctors");
  const [nodeOptions, setNodeOptions] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const inputRef = useRef({});
  // const inputRef = useRef({
  //   doctorId: "",
  //   name: "",
  //   fullnameEn: "",
  //   fullnameTh: "",
  //   node: "",
  //   accessToken: "",
  //   email: "",
  //   status: "",
  //   node: [],
  //   designation: "",
  //   licenseId: "",
  //   doctorType: "",
  //   paymentSource: "", // ✅ Doctor Payment Source
  //   note: "",
  //   diagnosisCashRate: "",
  //   diagnosisSocialSecurityRate: "",
  //   postConsultCashRate: "",
  //   postConsultSocialSecurityRate: "",
  //   cpapFollowupCashRate: "",
  //   cpapFollowupSocialSecurityRate: "",
  // });

  const handleChange = (name) => (e) => {
    inputRef.current[name] = e.target.value;
  };
  const handleSelected = (selectedOption) => {
    setSelectedOptions(selectedOption);
  };

  const handleOnHideModal = () => {
    props.hide();
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   const hasPaymentAccess = props.paymentAccessEmails.includes(
  //     props.currentUser.email
  //   );
  //   const selectedNode = selectedOptions.map((item) => item.value);

  //   const getVal = (key) =>
  //     inputRef.current[key] !== undefined && inputRef.current[key] !== ""
  //       ? inputRef.current[key]
  //       : props.item[key];

  //   const formData = {
  //     doctorId: getVal("doctorId"),
  //     name: getVal("name"),
  //     fullnameEn: getVal("fullnameEn"),
  //     fullnameTh: getVal("fullnameTh"),
  //     node: selectedOptions.length !== 0 ? selectedNode : props.item.node,
  //     accessToken: getVal("accessToken"),
  //     email: getVal("email"),
  //     status: getVal("status"),
  //     note:
  //       getVal("note") !== undefined && getVal("note") !== null
  //         ? getVal("note")
  //         : "",
  //     designation:
  //       getVal("designation") !== undefined && getVal("designation") !== null
  //         ? getVal("designation")
  //         : "",
  //     licenseId:
  //       getVal("licenseId") !== undefined && getVal("licenseId") !== null
  //         ? getVal("licenseId")
  //         : "",
  //     doctorType:
  //       getVal("doctorType") !== undefined && getVal("doctorType") !== null
  //         ? getVal("doctorType")
  //         : "",

  //     // ⬇️ Rate fields (preserve old values if user cannot access)
  //     diagnosisCashRate: hasPaymentAccess
  //       ? inputRef.current.diagnosisCashRate !== undefined
  //         ? inputRef.current.diagnosisCashRate
  //         : props.item.diagnosisCashRate
  //       : props.item.diagnosisCashRate,
  //     diagnosisSocialSecurityRate: hasPaymentAccess
  //       ? inputRef.current.diagnosisSocialSecurityRate !== undefined
  //         ? inputRef.current.diagnosisSocialSecurityRate
  //         : props.item.diagnosisSocialSecurityRate
  //       : props.item.diagnosisSocialSecurityRate,
  //     postConsultCashRate: hasPaymentAccess
  //       ? inputRef.current.postConsultCashRate !== undefined
  //         ? inputRef.current.postConsultCashRate
  //         : props.item.oppostConsultCashRatedRate
  //       : props.item.postConsultCashRate,
  //     postConsultSocialSecurityRate: hasPaymentAccess
  //       ? inputRef.current.postConsultSocialSecurityRate !== undefined
  //         ? inputRef.current.postConsultSocialSecurityRate
  //         : props.item.postConsultSocialSecurityRate
  //       : props.item.postConsultSocialSecurityRate,
  //     cpapFollowupCashRate: hasPaymentAccess
  //       ? inputRef.current.cpapFollowupCashRate !== undefined
  //         ? inputRef.current.cpapFollowupCashRate
  //         : props.item.cpapFollowupCashRate
  //       : props.item.cpapFollowupCashRate,
  //     cpapFollowupSocialSecurityRate: hasPaymentAccess
  //       ? inputRef.current.cpapFollowupSocialSecurityRate !== undefined
  //         ? inputRef.current.cpapFollowupSocialSecurityRate
  //         : props.item.cpapFollowupSocialSecurityRate
  //       : props.item.cpapFollowupSocialSecurityRate,
  //   };

  //   try {
  //     await updateDocument(props.item.id, formData);
  //     notifyTopRight("บันทึกข้อมูลสำเร็จ");
  //   } catch (err) {
  //     notifyError("บันทึกข้อมูลผิดพลาด ", err);
  //   }

  //   props.hide();

  //   // reset only visible fields
  //   const keysToReset = [
  //     "doctorId",
  //     "name",
  //     "fullnameEn",
  //     "fullnameTh",
  //     "node",
  //     "accessToken",
  //     "email",
  //     "status",
  //     "note",
  //     "designation",
  //     "licenseId",
  //     "doctorType",
  //   ];
  //   if (hasPaymentAccess)
  //     keysToReset.push(
  //       "diagnosisCashRate",
  //       "diagnosisSocialSecurityRate",
  //       "postConsultCashRate",
  //       "postConsultSocialSecurityRate",
  //       "cpapFollowupCashRate",
  //       "cpapFollowupSocialSecurityRate"
  //     );

  //   keysToReset.forEach((k) => (inputRef.current[k] = ""));
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const hasPaymentAccess = props.paymentAccess === true;

    const selectedNode = selectedOptions.map(function (item) {
      return item.value;
    });

    // Use this when empty string should NOT overwrite old value
    // Example: name, email, status, rates
    const getVal = function (key, defaultValue = "") {
      const newValue = inputRef.current[key];

      if (newValue !== undefined && newValue !== null && newValue !== "") {
        return newValue;
      }

      if (
        props.item &&
        props.item[key] !== undefined &&
        props.item[key] !== null
      ) {
        return props.item[key];
      }

      return defaultValue;
    };

    // Use this when empty string IS allowed
    // Example: note, designation, licenseId
    const getOptionalVal = function (key, defaultValue = "") {
      const newValue = inputRef.current[key];

      if (newValue !== undefined && newValue !== null) {
        return newValue;
      }

      if (
        props.item &&
        props.item[key] !== undefined &&
        props.item[key] !== null
      ) {
        return props.item[key];
      }

      return defaultValue;
    };

    const formData = {
      doctorId: getVal("doctorId"),
      name: getVal("name"),
      fullnameEn: getVal("fullnameEn"),
      fullnameTh: getVal("fullnameTh"),

      node: selectedOptions.length !== 0 ? selectedNode : props.item.node || [],

      accessToken: getVal("accessToken"),
      email: getVal("email"),
      status: getVal("status"),

      note: getOptionalVal("note", ""),
      designation: getOptionalVal("designation", ""),
      licenseId: getOptionalVal("licenseId", ""),
      doctorType: getOptionalVal("doctorType", ""),

      paymentSource: getOptionalVal("paymentSource", ""),

      diagnosisCashRate: hasPaymentAccess
        ? getVal("diagnosisCashRate", "")
        : props.item.diagnosisCashRate || "",

      diagnosisSocialSecurityRate: hasPaymentAccess
        ? getVal("diagnosisSocialSecurityRate", "")
        : props.item.diagnosisSocialSecurityRate || "",

      postConsultCashRate: hasPaymentAccess
        ? getVal("postConsultCashRate", "")
        : props.item.postConsultCashRate || "",

      postConsultSocialSecurityRate: hasPaymentAccess
        ? getVal("postConsultSocialSecurityRate", "")
        : props.item.postConsultSocialSecurityRate || "",

      cpapFollowupCashRate: hasPaymentAccess
        ? getVal("cpapFollowupCashRate", "")
        : props.item.cpapFollowupCashRate || "",

      cpapFollowupSocialSecurityRate: hasPaymentAccess
        ? getVal("cpapFollowupSocialSecurityRate", "")
        : props.item.cpapFollowupSocialSecurityRate || "",
    };

    try {
      await updateDocument(props.item.id, formData);
      notifyTopRight("บันทึกข้อมูลสำเร็จ");

      props.hide();

      inputRef.current = {};
      setSelectedOptions([]);
    } catch (err) {
      notifyError("บันทึกข้อมูลผิดพลาด ", err);
    }
  };
  const getNodeName = async () => {
    const ref = collection(db, "nodes");

    const docSnap = await getDocs(ref);
    const temp = [];
    docSnap.forEach((item) => {
      temp.push({ value: item.data().nodename, label: item.data().nodename });
    });
    setNodeOptions(temp);
  };

  useEffect(() => {
    getNodeName();
  }, []);

  return (
    <Fragment>
      <Toast />
      <Modal
        className="fade bd-example-modal-lg"
        show={props.show}
        onHide={handleOnHideModal}
        size="lg"
      >
        <Modal.Header>
          <Modal.Title>Edit Doctor Datails</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <DoctorEditForm
            onChange={handleChange}
            initailValues={props.item}
            node={nodeOptions}
            onSelect={handleSelected}
            currentUser={props.currentUser}
            paymentAccess={props.paymentAccess}
          />
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
        <div className="d-flex justify-content-center mb-3">
          <Button className="sm" onClick={handleSubmit}>
            Save
          </Button>

          <Button
            className="sm ml-2"
            variant="light"
            onClick={handleOnHideModal}
          >
            Cancel
          </Button>
        </div>
      </Modal>
    </Fragment>
  );
};

export default DoctorEdit;
